export const config = {
  networkId: process.env.REACT_APP_NETWORKID || 1,
  tokenContractAddress:
    process.env.REACT_APP_TOKENCONTRACTADDRESS ||
    "0x88200d826B228d899056Ae4832c2AE45F4E46Cf8",
  pepeContractAddress:
    process.env.REACT_APP_PEPECONTRACTADDRESS ||
    "0x6982508145454Ce325dDbE47a25d4ec3d2311933",
  totalSupply: 6969,
  totalMinted: undefined as number | void, // set to 6969 when sold out
  mintPrice: 69420000,
  mintCurrency: "$PEPE",
  frogsoverdogsTwitterHashLink: "https://twitter.com/search?q=%23frogsoverdogs",
  pepeUniswapLink:
    "https://app.uniswap.org/#/swap?inputCurrency=ETH&outputCurrency=0x6982508145454Ce325dDbE47a25d4ec3d2311933",
  openseaDomain: "opensea.io",
  openseaCollectionName: "frogsoverdogs",
};
